import { render, staticRenderFns } from "./GestionCatequistas.vue?vue&type=template&id=a13e09fc&"
import script from "./GestionCatequistas.vue?vue&type=script&lang=js&"
export * from "./GestionCatequistas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports